<template>

    <div class="checkbox" :class="{ disabled: disabled, multiline: multiline }">
        <input type="checkbox" v-model="val" :disabled="disabled">
        <div class="checkmark" @click.stop="toggle">
            <i class="icon"></i>
        </div>
        <span v-if="label" class="label" @click.stop="toggle">{{ label }}</span>
    </div>

</template>

<style scoped lang="scss">

    .checkbox {

        align-items: center;
        background: transparent;
        display: flex;
        overflow: hidden;
        position: relative;
        z-index: 0;

        &.multiline {
            align-items: flex-start;
            .label {
                white-space: normal;
            }
        }

        &.disabled .checkmark {
            background: $color-bg;
            opacity: 0.5;
        }

        input {
            height: 0;
            line-height: 0;
            opacity: 0;
            width: 0;
        }

        .checkmark {
            align-items: center;
            background-color: $color-white;
            border: 1px solid $color-rule;
            border-radius: 5px;
            box-sizing: border-box;
            cursor: pointer;
            display: flex;
            justify-content: center;
            flex-shrink: 0;
            height: 18px;
            margin: 0;
            padding: 0;
            position: relative;
            transition: border-color .3s;
            width: 18px;
            .icon {
                display: none;
                width: 5px;
                height: 10px;
                border: solid $color-primary;
                border-width: 0 2px 2px 0;
                margin-top: -2px;
                transform: rotate(45deg);
            }
        }

        .label {
            @include font-regular(13px);
            color: $color-text;
            cursor: pointer;
            line-height: 1.4em;
            margin-left: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            user-select: none;
            white-space: nowrap;
        }

        &:hover .checkmark {
            border-color: $color-text;
        }

        input:checked ~ .checkmark {
            background-color: $color-white;
            border-color: $color-primary;
            .icon {
                display: block;
            }
        }

    }

</style>

<script>

export default {

    props: {
        model: {
            required: true,
        },
        label: {
            type: String,
        },
        multiline: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            val: this.model,
        }
    },

    watch: {

        model(val) {
            this.val = val;
        },

    },

    methods: {

        toggle() {
            if (!this.disabled) {
                this.val = !this.val;
                this.$emit('input', this.val);
            }
        },

    },

}

</script>
